interface GeolocationResult {
  latitude: number;
  longitude: number;
  accuracy: number;
}

export function useGeolocation() {
  function getLocation(): Promise<GeolocationResult | null> {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        console.warn("[Geolocation] Not supported by this browser.");
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
          });
        },
        (error) => {
          console.warn(
            "[Geolocation] Permission denied or error:",
            error.message,
          );
          resolve(null);
        },
        {
          enableHighAccuracy: false,
          timeout: 10000,
          maximumAge: 300000,
        },
      );
    });
  }

  return { getLocation };
}
